<div class="fixed flex flex-col top-9 left-0 px-4 pt-12 h-full w-full bg-white">
  <!-- Menu Items -->
  <a (click)="onCloseMenuClick()" class="font-semibold text-xl text-[#161D26] mb-4 leading-6 cursor-pointer" routerLink="/main">Start</a>
  <a (click)="onCloseMenuClick()" class="font-semibold text-xl text-[#161D26] mb-4 leading-6 cursor-pointer" routerLink="/entry/search">Suche</a>
  <a (click)="onCloseMenuClick()" class="font-semibold text-xl text-[#161D26] mb-4 leading-6 cursor-pointer" routerLink="/entry/create">Anzeige aufgeben</a>
  @if (_auth.isAuthenticated()) {
    <a (click)="onCloseMenuClick()" class="font-semibold text-xl text-[#161D26] mb-4 leading-6 cursor-pointer" [routerLink]="['/profile/menu',NavigationBarItem.MESSAGES]">Nachrichten</a>
  }
  <a (click)="onCloseMenuClick()" class="font-semibold text-xl text-[#161D26] mb-4 leading-6 cursor-pointer" routerLink="/profile">Konto</a>
  <a (click)="onCloseMenuClick()" class="font-semibold text-xl text-[#161D26] mb-4 leading-6 cursor-pointer" routerLink="/faq">FAQ</a>
  <!-- Divider -->
  <div class="w-full bg-[#EFEFEF] h-[1px] my-8"></div>

  @if (!_auth.isAuthenticated()) {
    <span class="font-medium text-base text-[#161D26] mb-4 leading-6 cursor-pointer">
      <a class="text-kaz-orange" routerLink="/login">Anmelden</a>
      oder
      <a class="text-kaz-orange" routerLink="/signup">Konto erstellen</a>
    </span>
  }
  @if (_auth.isAuthenticated()) {
    <div class="flex flex-col">
      <a class="text-kaz-orange text-base font-medium" routerLink="/login" (click)="logout()">Abmelden</a>
      <span class="text-xs text-[#A7A7A7] font-normal">{{mail}}</span>
    </div>
  }
</div>
